import './App.css';
import MovieList from './Component/MovieList';
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from 'react';
import { MovieListHeading } from './Component/MovieListHeading';
import { SearchBox } from './Component/SearchBox';
import { AddFavorite } from './Component/AddFavorite';
import { DeleteFavorite } from './Component/DeleteFavorite';

function App() {
  // State to hold the list of movies fetched from the API
  const [movies, setMovies] = useState([]);

  // State to hold the current search value from the search box
  const [searchValue, setSearchValue] = useState('');

  // State to hold the list of favorite movies
  const [favorite, setFavorites] = useState([]);

  // Function to fetch movies from the OMDB API based on the search value
  const getMovieRequest = async () => {
    // Use environment variables for API URL and key
    const url = `http://www.omdbapi.com/?s=${searchValue}&apikey=ba595712`;

    const response = await fetch(url); // Make the API request
    const responseJson = await response.json(); // Convert the response to JSON

    // Check if the API returned any movies
    if (responseJson.Search) {
      setMovies(responseJson.Search); // Update movies state with the fetched movies
    } else {
      setMovies([]); // If no movies found, set movies state to an empty array
    }

    console.log(responseJson); // Log the API response to the console for debugging
  };

  // useEffect to trigger movie fetch whenever the search value changes
  useEffect(() => {
    getMovieRequest(searchValue);
  }, [searchValue]);

  // useEffect to load favorite movies from local storage when the component mounts
  useEffect(() => {
    const movieFavorite = JSON.parse(localStorage.getItem('favoritelist')); // Get favorites from local storage
    setFavorites(movieFavorite); // Update favorites state with the loaded favorites
  }, []);

  // Function to save the favorite movies list to local storage
  const saveToLocalStorage = (items) => {
    localStorage.setItem('favoritelist', JSON.stringify(items)); // Save the updated favorites list
  };

  // Function to add a movie to the list of favorite movies
  const addFavoriteMovie = (movie) => {
    const newFavoriteList = [...favorite, movie]; // Create a new list with the added favorite
    setFavorites(newFavoriteList); // Update the state with the new list
    saveToLocalStorage(newFavoriteList); // Save the new list to local storage
  };

  // Function to remove a movie from the list of favorite movies
  const removeFavoriteMovie = (movie) => {
    const newFavoriteList = favorite.filter((favorite) => favorite.indbID !== movie.indbID); // Filter out the movie to remove
    setFavorites(newFavoriteList); // Update the state with the filtered list
  };

  return (
    <div className="container-fluid movie-app">
      <div className='row d-flex align-items-center pt-3 pb-3 shadow-sm'>
        <MovieListHeading heading="Movies" /> {/* Header for the movies section */}
        <SearchBox searchValue={searchValue} setSearchValue={setSearchValue} /> {/* Search box component */}
      </div>
      <div className='row'>
        <MovieList
          movies={movies} 
          handleFavoriteClick={addFavoriteMovie} 
          favoriteComponent={AddFavorite} 
        /> {/* Component to display list of movies */}
      </div>
      <div className='row d-flex align-items-center pt-3 pb-3 shadow-sm'>
        <MovieListHeading heading="Favorites" /> {/* Header for the favorites section */}
      </div>
      <div className='row'>
        <MovieList
          movies={favorite} 
          handleFavoriteClick={removeFavoriteMovie} 
          favoriteComponent={DeleteFavorite} 
        /> {/* Component to display list of favorite movies */}
      </div>
    </div>
  );
}

export default App;
